module.exports = __webpack_public_path__ + "img/teacher.af3347d8.svg";